import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { toast, ScrollIntoView } from '@grandvisionhq/common';
import { H2, H3, Alert } from '@grandvisionhq/iris-ui';
import { PaymentMethod, PaymentServiceProvider, PaymentFlow, PaypalPaymentEventsProvider, PaymentMethodsUI } from '@grandvisionhq/payments';
import { useIntl } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../context/CheckoutSettings/context.js';
import { pushDonationSelectEventToDataLayer } from '../../../data-layer.js';
import { useAddAdditionalCosts } from '../../../hooks/carts/use-add-additional-costs.js';
import '@grandvisionhq/utils';
import '../../../StepShipping/selectors.js';
import 'lodash/isEmpty';
import '../../../mappers/errors-mapping.js';
import '../../../utils/get-customer-details-payload.js';
import '../../../models/cart/cart-state.js';
import { CheckoutStepErrorType } from '../../../models/checkout/checkout-step-error-type.js';
import '../../../models/checkout-settings.js';
import '../../../models/step-shipping/shipping-methods.js';
import '../../../models/shared.js';
import 'history';
import { useGetQueryParams } from '../../../utils/get-query-params.js';
import '../../../utils/has-cart-errors.js';
import '@grandvisionhq/auth';
import '../../../selectors.js';
import '@grandvisionhq/graphql';
import '@grandvisionhq/lib-utils-cart';
import '@grandvisionhq/svc-tealium/events';
import '../../../operations/mutations/set-customer-details.js';
import '../../../operations/mutations/set-service-store.js';
import '../../../operations/mutations/set-shipping-method.js';
import '../../../operations/mutations/set-shipping-state.js';
import '../../../operations/mutations/set-store.js';
import '../../../operations/mutations/create-apple-pay-session.js';
import '../../../operations/mutations/recreate-ordered-checkout.js';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/fun-orders';
import '@grandvisionhq/analytics';
import '../../../operations/fragments/checkout-mutation-result.js';
import '../../../operations/fragments/cart-mutation-failures.js';
import '../../../operations/fragments/recreate-ordered-checkout-failure.js';
import '../../../operations/fragments/recreate-ordered-checkout-result.js';
import '../../../operations/fragments/paypal-payment.js';
import '../../../operations/fragments/saved-user-details.js';
import '../../../operations/queries/get-checkout-state.js';
import '../../../operations/queries/get-user-details.js';
import '@grandvisionhq/icons';
import '@grandvisionhq/locations';
import '../../../StepShipping/modules/ShippingMethods/containers/PickupPointsFinderContainer.js';
import '../../../StepShipping/modules/ShippingMethods/containers/StoresFinderContainer.js';
import '@grandvisionhq/elements';
import '@grandvisionhq/shipping';
import '@grandvisionhq/forms';
import '../../../state.js';
import '@grandvisionhq/lib-utils-html';
import 'classnames';
import '../../../modules/ExpressCheckout/components/ExpressCheckoutContainer.js';
import 'motion/react';
import 'throttle-debounce';
import '../../../slots/forms/form-context.js';
import '../../../slots/summaries/summary-context.js';
import '../../../slots/summaries/types.js';
import '../../../modules/ServiceStore/containers/ServiceStoreContainer.js';
import '@grandvisionhq/stores-v2';
import '@grandvisionhq/my-account';
import { LoaderModal } from '../../../modules/LoaderModal/LoaderModal.js';
import '@grandvisionhq/bloomreach';
import { useHandleQueryParams } from '../../../StepPayment/hooks/use-handle-query-params.js';
import { useHandleQrFormUpdates } from '../../../StepPayment/hooks/use-handle-qr-form-updates.js';
import { useLoggedInCheckout } from '../../context/context.js';
import '@grandvisionhq/lib-utils-w3c';
import { useHandleApplePay } from '../../hooks/useHandleApplePay.js';
import { useHandleGpayConfig } from '../../hooks/useHandleGpayConfig.js';
import { useHandlePaypalConfig } from '../../hooks/useHandlePaypalConfig.js';
import { useHandleOrderCreation } from '../../hooks/useHandlerOrderCreation.js';
import { useValidateAndSetOrderDetails } from '../../hooks/useValidateAndSetOrderDetails.js';

const PaymentsContainer = ({ selfUrl , updateCheckoutStatus  })=>{
    const { status , cartId , type: paymentType  } = useGetQueryParams();
    const [isFailedCheckoutStep, setIsFailedCheckoutStep] = React.useState(false);
    const [updateUrlQueryParam, deleteQueryParam] = useHandleQueryParams();
    const { cart , loading  } = Context.useCart();
    const { getLabel  } = useIntl();
    const { selectedShippingMethod , consents , isSaveDetailsInAccount , isOrderInProgress , setIsOrderInProgress ,  } = useLoggedInCheckout();
    const [paymentDetailsState, setPaymentDetailsState] = React.useState(undefined);
    const { addAdditionalPaymentCostsIfApplicable  } = useAddAdditionalCosts();
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState();
    const [donationInfo, setDonationInfo] = React.useState();
    const paypalAndGpayInputProp = React.useMemo(()=>({
            selfUrl,
            selectedPaymentMethod,
            donationInfo,
            selectedShippingMethod,
            consents,
            isSaveDetailsInAccount,
            setIsOrderInProgress
        })
    , [
        consents,
        donationInfo,
        isSaveDetailsInAccount,
        selectedPaymentMethod,
        selectedShippingMethod,
        selfUrl,
        setIsOrderInProgress, 
    ]);
    const { paypalPaymentEvents , handlePaypalCtaClick , onPaypalError  } = useHandlePaypalConfig(paypalAndGpayInputProp);
    const { paymentMethodLogos  } = useCheckoutSettings();
    const { handlePlaceOrder , orderResponse , paymentFlow  } = useHandleOrderCreation();
    const { handleGpayCtaClick , onGpayAuthorized  } = useHandleGpayConfig(paypalAndGpayInputProp);
    const { payWithApplePay  } = useHandleApplePay({
        selfUrl,
        donationInfo,
        consents,
        isSaveDetailsInAccount,
        setIsOrderInProgress
    });
    const PaymentMethodsWithPopUpScreen = React.useMemo(()=>[
            PaymentMethod.PAYPAL,
            PaymentMethod.GOOGLE_PAY,
            PaymentMethod.APPLE_PAY
        ]
    , []);
    const handleCreateOrder = React.useCallback(()=>{
        if (isFailedCheckoutStep) setIsFailedCheckoutStep(false);
        const isAdyenPaypal = (selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type) === PaymentMethod.PAYPAL && selectedPaymentMethod.provider == PaymentServiceProvider.ADYEN;
        if (paymentDetailsState && (selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type) && (isAdyenPaypal || !PaymentMethodsWithPopUpScreen.includes(selectedPaymentMethod.type))) {
            handlePlaceOrder({
                selfUrl,
                selectedPaymentMethod,
                donationInfo,
                paymentDetails: paymentDetailsState,
                consents,
                isSaveDetailsInAccount,
                setIsOrderInProgress
            });
        }
    }, [
        PaymentMethodsWithPopUpScreen,
        consents,
        donationInfo,
        handlePlaceOrder,
        isFailedCheckoutStep,
        isSaveDetailsInAccount,
        paymentDetailsState,
        selectedPaymentMethod,
        selfUrl,
        setIsOrderInProgress, 
    ]);
    const { saveCustomerInformation  } = useValidateAndSetOrderDetails({
        onComplete: handleCreateOrder
    });
    var ref;
    const paymentMethodType = (ref = selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type) !== null && ref !== void 0 ? ref : PaymentMethod.SWISH;
    /**
   * @description
   * qrCodeFormData is needed for the new paymentMethodsUI and
   * useHandleQrFormUpdates hook also handles the QrForm state changes
   */ const [qrCodeFormData] = useHandleQrFormUpdates(swcHelpers.objectSpread({}, orderResponse ? {
        qrPaymentConfig: {
            qrCodeExpiresIn: orderResponse.qrCodeExpiresIn,
            qrCodeUrl: orderResponse.qrCodeUrl,
            redirectUrl: orderResponse.redirectUrl
        }
    } : {}, {
        paymentFlow,
        selfUrl,
        paymentMethodType,
        paymentMethodLogos,
        orderId: paymentFlow === PaymentFlow.QR_CODE ? orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.orderId : undefined,
        orderDataToken: orderResponse === null || orderResponse === void 0 ? void 0 : orderResponse.orderDataToken
    }));
    const isPaymentStepValid = React.useCallback((paymentDetails)=>{
        const isValid = paymentDetails && paymentDetails.isValid;
        if (!isValid) {
            toast.failed('checkout.errors.form.payment.details');
        }
        return Boolean(isValid);
    }, []);
    const resetPaymentStatus = React.useCallback(()=>{
        if ((selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type) && status !== '') {
            updateCheckoutStatus === null || updateCheckoutStatus === void 0 ? void 0 : updateCheckoutStatus('');
            deleteQueryParam([
                'status'
            ]);
            setIsFailedCheckoutStep(false);
        }
    }, [
        deleteQueryParam,
        selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type,
        status,
        updateCheckoutStatus
    ]);
    const handleNextClick = React.useCallback(swcHelpers.asyncToGenerator(function*({ paymentDetailsConfig  } = {}) {
        if (isPaymentStepValid(paymentDetailsConfig)) {
            setPaymentDetailsState(paymentDetailsConfig);
            updateCheckoutStatus === null || updateCheckoutStatus === void 0 ? void 0 : updateCheckoutStatus('');
            resetPaymentStatus();
            if ((selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type) === PaymentMethod.APPLE_PAY) {
                payWithApplePay({
                    selectedShippingMethod,
                    consents
                });
            } else {
                setIsOrderInProgress(true);
                yield saveCustomerInformation(selectedShippingMethod, consents).then(({ success  })=>{
                    if (!success) {
                        setIsOrderInProgress(false);
                    }
                }).catch(()=>setIsOrderInProgress(false)
                );
            }
        }
    }), [
        consents,
        isPaymentStepValid,
        payWithApplePay,
        resetPaymentStatus,
        saveCustomerInformation,
        selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type,
        selectedShippingMethod,
        setIsOrderInProgress,
        updateCheckoutStatus, 
    ]);
    /**
   * @description
   *  Callback method to provide details of selected payment method
   * @param paymentMethodConfig
   *  config of selected Payment method
   */ const handleOnPaymentMethodSelected = React.useCallback((paymentMethodConfig)=>{
        setDonationInfo(undefined);
        setSelectedPaymentMethod(paymentMethodConfig);
        updateUrlQueryParam({
            type: paymentMethodConfig.type
        });
        /**
       *  Condition to change error status when user try to
       *  complete payment using different method
       */ if ((selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type) && selectedPaymentMethod.type !== paymentMethodConfig.type && status !== '') {
            updateCheckoutStatus === null || updateCheckoutStatus === void 0 ? void 0 : updateCheckoutStatus('');
            deleteQueryParam([
                'status'
            ]);
        }
    }, [
        deleteQueryParam,
        selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type,
        status,
        updateCheckoutStatus,
        updateUrlQueryParam, 
    ]);
    /* onHandlePayment */ const onHandlePayment = React.useCallback((selectedPaymentConfig)=>{
        selectedPaymentConfig && updateUrlQueryParam({
            type: selectedPaymentConfig.type
        });
        handleNextClick({
            paymentDetailsConfig: selectedPaymentConfig
        });
    }, [
        updateUrlQueryParam,
        handleNextClick
    ]);
    /**
   * @description
   *  Callback method to store donation in the Redux store
   * @param donation
   *  donation amount
   */ const handleDonation = React.useCallback((donationPayload)=>{
        pushDonationSelectEventToDataLayer(donationPayload.foundationKey, donationPayload.amount);
        selectedPaymentMethod && setDonationInfo({
            key: donationPayload.foundationKey,
            amount: donationPayload.amount,
            paymentMethod: selectedPaymentMethod === null || selectedPaymentMethod === void 0 ? void 0 : selectedPaymentMethod.type
        });
    }, [
        selectedPaymentMethod
    ]);
    React.useEffect(()=>{
        if (status && [
            CheckoutStepErrorType.Failed,
            CheckoutStepErrorType.Cancelled,
            CheckoutStepErrorType.Refused,
            CheckoutStepErrorType.Error,
            CheckoutStepErrorType.InternalError, 
        ].includes(status)) {
            if (!loading) {
                setIsFailedCheckoutStep(true);
            }
        }
    }, [
        status,
        loading
    ]);
    var ref1;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(LoaderModal, {
        isModalOpen: isOrderInProgress,
        subheading: getLabel('checkout.order.inprogress')
    }), /*#__PURE__*/ React.createElement(H2, {
        variant: "heading-small"
    }, getLabel('checkout.instant.payment.heading')), /*#__PURE__*/ React.createElement(H3, {
        variant: "text-body"
    }, getLabel('checkout.instant.payment.subheading')), isFailedCheckoutStep && /*#__PURE__*/ React.createElement(ScrollIntoView, {
        key: "payment-error"
    }, /*#__PURE__*/ React.createElement(Alert, {
        role: "alert",
        "aria-describedby": "payment-alert",
        className: "alert-m-default ",
        variant: "warning",
        title: getLabel('checkout.errors.general.title')
    }, getLabel('checkout.errors.general.message'))), /*#__PURE__*/ React.createElement(PaypalPaymentEventsProvider, swcHelpers.extends({}, paypalPaymentEvents, {
        onClick: handlePaypalCtaClick,
        orderType: (cart === null || cart === void 0 ? void 0 : cart.hasSubscription) ? 'subscription' : 'regular',
        onError: onPaypalError
    }), /*#__PURE__*/ React.createElement(PaymentMethodsUI, {
        cartId: cartId,
        qrCodeForm: qrCodeFormData,
        onPaymentMethodSelected: handleOnPaymentMethodSelected,
        selectedDonation: donationInfo === null || donationInfo === void 0 ? void 0 : donationInfo.amount,
        onDonationSelected: handleDonation,
        paymentMethodName: (ref1 = paymentType) !== null && ref1 !== void 0 ? ref1 : '',
        onHandlePayment: onHandlePayment,
        addAdditionalPaymentCosts: addAdditionalPaymentCostsIfApplicable,
        isOrderInProgress: false,
        totalPrice: cart === null || cart === void 0 ? void 0 : cart.prices.totalPrice,
        googlePayActions: {
            handleGpayCtaClick,
            onAuthorize: onGpayAuthorized
        }
    })));
};

export { PaymentsContainer };
//# sourceMappingURL=PaymentsContainer.js.map
